import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useParams } from "react-router-dom";
import api from '../utils/intercepter/axiosConfig.js'
import { useNavigate } from "react-router-dom";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FaArrowDown } from "react-icons/fa";

const TrConservation = () => {

    const {w_id} = useParams();
    const [montant, setMontant] = useState(0);
    const [num_tr_code, setNumTrCode] = useState(0);

    const [etat_tr_conservation, setEtatTrConservation] = useState(0);

    const {state} = useLocation();

    const id_quittance_tr_conservation = state?.id_quittance;
    const etat_liquidation_id_tr_conservation = state?.etat_liquidation_id;

    useEffect(() => {
        if(id_quittance_tr_conservation && etat_liquidation_id_tr_conservation && w_id){
            console.log("id quittance : ", id_quittance_tr_conservation);
             console.log("etat_liquidation_id_tr_conservation : ", etat_liquidation_id_tr_conservation);
              console.log("w_id : ", w_id);
        }

    },[id_quittance_tr_conservation,etat_liquidation_id_tr_conservation, w_id])

    const id_vente = state?.id_vente;
    console.log("num_vente : ", id_vente);

    const navigate = useNavigate();
    
    const fetchTrConservationByWId = async () => {
        try {
            const response = await api.post("/auth/getTrConservationOfMutation",{
                w_id: w_id
            });
            
            if(response.data.status){
                setMontant(response.data.response.montant)
                setNumTrCode(response.data.response.num_tr);
                setEtatTrConservation(response.data.response.etat);
            }
            else{
                console.log("Aucun TF Conservation")
            }
        } catch (error) {
            console.log("Erreur Connexion")
        }
    }

    useEffect(() => {

        if(w_id){

           fetchTrConservationByWId();

        }
    }, [w_id])
    
  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">TR Conservation</h2>

      <div className="card">
        <div className="card-body">
        
        <table className="table table-bordered">

                    <tbody>
                        <tr>
                        <td className="text-start">
                            Montant
                            </td>
                           <td>
                            {montant ? montant.toLocaleString() : "N/A"} MRU
                            </td> 
                        </tr>

                        <tr>
                        <td className="text-start">
                        Code
                            </td>
                           <td>
                           {num_tr_code.toLocaleString()}
                            </td> 
                        </tr>

                        <tr>
                        <td className="text-start">
                        Opérations
                            </td>
                           <td  className="d-flex align-items-center gap-2">
                           
                           <button className="btn btn-warning btn-sm d-flex align-items-center"
                                                            >
                            <FaArrowDown size={20} style={{marginRight:'10px'}}
                            />
                                Télécharger
                               </button>

                                {etat_tr_conservation === 0 ? (<button className="btn btn-success btn-sm d-flex align-items-center"
                                
                                                           onClick={() => navigate(`/vente/paiements/${w_id}`,{
                                                             state: {
                                                              id_vente: id_vente
                                                             } 
                                                            })}
                                                            >
                                        <AiOutlineCheckCircle size={20} style={{ marginRight: '5px' }} />
                                        Payé
                                        </button>) : (<button className="btn btn-success btn-sm d-flex align-items-center"
                                                          
                                                          onClick={() => {
                                                              navigate(`/vente/quittance/tr/conservation/${id_quittance_tr_conservation}/${w_id}/${etat_liquidation_id_tr_conservation}`)
                                                            }}

                                                            >
                                        <AiOutlineCheckCircle size={20} style={{ marginRight: '5px' }} />
                                        Quittance
                                        </button>)}

                            </td> 
                        </tr>
                        
                    </tbody>
                </table>
          
        </div>
      </div>
    </div>
  );
};

export default TrConservation;
